<template>
    <div>
      <div class="driver__container">
        <side-menu/>
        <router-view />
      </div>
      <footer-view style="border-top: 1px solid;"></footer-view>
    </div>
</template>

<script>
import SideMenu from './../../components/menu/SideMenu.vue'
import FooterView from '@components/footer/FooterView.vue'
import store from '@store/index.js'
export default {
  name: 'Admin',
  components: {
    SideMenu,
    FooterView
  },
  data: function () {
    return {
      store: store
    }
  }
}
</script>
